import { IFilter } from '../../types/advancedFilters';
import { DealTypeContainer } from '../../containers/advancedFilters/DealTypeContainer';

export const dealType: IFilter = {
  component: DealTypeContainer,
};
